import { extractDicomFilesFromZip } from './extractZipDicomFiles';
import { IMPORT_STUDY_MESSAGES } from './importStudyMessages';
import {
  isImportStudyDicomFile,
  isImportStudyZipFile,
  type ImportStudyFile,
} from './importStudyValidation';

export type CollectImportStudyDicomFilesResult =
  | { success: true; dicomFiles: File[] }
  | { success: false; message: string };

/**
 * Collects DICOM files from a mixed selection of .dcm and .zip inputs.
 * DICOM files are accepted by extension/MIME and validated during parsing.
 */
export async function collectImportStudyDicomFiles(
  files: ImportStudyFile[]
): Promise<CollectImportStudyDicomFilesResult> {
  const dicomFiles: File[] = [];
  let hadZipInput = false;

  for (const file of files) {
    if (isImportStudyZipFile(file)) {
      hadZipInput = true;
      const zipResult = await extractDicomFilesFromZip(file);
      if (!zipResult.success) {
        return zipResult;
      }

      dicomFiles.push(...zipResult.dicomFiles);
      continue;
    }

    if (isImportStudyDicomFile(file)) {
      dicomFiles.push(file);
    }
  }

  if (!dicomFiles.length) {
    const onlyZipInputs = hadZipInput && files.every(isImportStudyZipFile);
    return {
      success: false,
      message: onlyZipInputs
        ? IMPORT_STUDY_MESSAGES.EMPTY_ZIP
        : IMPORT_STUDY_MESSAGES.NO_DICOM_FOUND,
    };
  }

  return { success: true, dicomFiles };
}
